<template>
    <div class="content-wrapper">
        <!-- Page Loader -->
        <div class="vld-parent">
            <loading :active.sync="isLoading" :is-full-page="fullPage"></loading>
        </div>

        <breadcrumb :page="$t('form.employee.professorList')"></breadcrumb>

        <div class="content">
            <div class="container-fluid">

                <b-alert v-model="alert" :variant="alertClass" dismissible fade>{{alertMessage}}</b-alert>

                <!-- Filters -->
                <div class="card">
                    <div class="card-header bg-light">
                        <div class="card-title">{{$t('filters')}}</div>
                        <div class="text-right">
                            <b-button variant="primary" size="sm" @click="detailedSearch = !detailedSearch">
                                {{$t('button.detailedSearch')}}</b-button>
                            <b-button variant="default" size="sm" @click="clearSearch()">{{$t('button.resetFilter')}}
                            </b-button>
                        </div>
                    </div>

                    <div class="card-body">

                        <div class="row">
                            <div class="col-sm-6">
                                <div class="form-group">
                                    <label>{{$t('form.employee.searchCriteria')}}</label>
                                    <v-select @input="loadPreset" label="name" :options="presetList" v-model="preset">
                                    </v-select>
                                </div>
                            </div>
                        </div>

                        <div class="row">
                            <div class="col-sm-3">
                                <div class="form-group">
                                    <label>{{$t('form.employee.name')}}</label>
                                    <input type="text" class="form-control" v-model="search.name"
                                        @keyup="searchProfessors" />
                                </div>
                            </div>

                            <div class="col-sm-3">
                                <div class="form-group">
                                    <label>{{$t('form.employee.department')}}</label>
                                    <v-select @input="searchProfessors" :options="departmentList"
                                        v-model="search.Department">
                                    </v-select>
                                </div>
                            </div>

                            <div class="col-sm-3">
                                <div class="form-group">
                                    <label>{{$t('form.employee.position')}}</label>
                                    <v-select @input="searchProfessors" :options="positionList"
                                        v-model="search.Position" :reduce="positionList => positionList">
                                    </v-select>
                                </div>
                            </div>

                            <div class="col-sm-3">
                                <div class="form-group">
                                    <label>{{$t('form.employee.title')}}</label>
                                    <v-select @input="searchProfessors" :options="titles" v-model="search.Title"
                                        :reduce="titles => titles"></v-select>
                                </div>
                            </div>
                        </div>

                        <div class="row" v-if="detailedSearch">

                            <div class="col-sm-3">
                                <div class="form-group">
                                    <label>{{$t('form.employee.firstName')}}</label>
                                    <input type="text" v-model="search.firstName" @keyup="searchProfessors"
                                        class="form-control" />
                                </div>
                            </div>

                            <div class="col-sm-3">
                                <div class="form-group">
                                    <label>{{$t('form.employee.lastName')}}</label>
                                    <input type="text" v-model="search.lastName" @keyup="searchProfessors"
                                        class="form-control" />
                                </div>
                            </div>

                            <div class="col-sm-3">
                                <div class="form-group">
                                    <label>{{$t('form.employee.birthDate')}}</label>
                                    <input type="date" v-model="search.birthDate" @change="searchProfessors"
                                        class="form-control" />
                                </div>
                            </div>

                            <div class="col-sm-3">
                                <div class="form-group">
                                    <label>{{$t('form.employee.birthPlace')}}</label>
                                    <input type="text" v-model="search.birthPlace" @keyup="searchProfessors"
                                        class="form-control" />
                                </div>
                            </div>

                            <div class="col-sm-3">
                                <div class="form-group">
                                    <label>{{$t('form.employee.birthCountry')}}</label>
                                    <v-select @input="searchProfessors" label="printable_name" :options="allCountries"
                                        v-model="search.birthCountry"
                                        :reduce="allCountries => allCountries.printable_name">
                                    </v-select>
                                </div>
                            </div>

                            <div class="col-sm-3">
                                <div class="form-group">
                                    <label>{{$t('form.employee.streetAddress')}}</label>
                                    <input type="text" v-model="search.streetAddress" @keyup="searchProfessors"
                                        class="form-control" />
                                </div>
                            </div>

                            <div class="col-sm-3">
                                <div class="form-group">
                                    <label>{{$t('form.employee.city')}}</label>
                                    <input type="text" v-model="search.city" @keyup="searchProfessors"
                                        class="form-control" />
                                </div>
                            </div>

                            <div class="col-sm-3">
                                <div class="form-group">
                                    <label>{{$t('form.employee.postalCode')}}</label>
                                    <input type="text" v-model="search.zip" @keyup="searchProfessors"
                                        class="form-control" />
                                </div>
                            </div>

                            <div class="col-sm-3">
                                <div class="form-group">
                                    <label>{{$t('form.employee.country')}}</label>
                                    <v-select @input="searchProfessors" label="printable_name" :options="allCountries"
                                        v-model="search.country" :reduce="allCountries => allCountries.printable_name">
                                    </v-select>
                                </div>
                            </div>

                            <div class="col-sm-3">
                                <div class="form-group">
                                    <label>{{$t('form.employee.phone')}}</label>
                                    <input type="text" v-model="search.phone" @keyup="searchProfessors"
                                        class="form-control" />
                                </div>
                            </div>

                            <div class="col-sm-3">
                                <div class="form-group">
                                    <label>{{$t('form.employee.mobile')}}</label>
                                    <input type="text" v-model="search.mobile" @keyup="searchProfessors"
                                        class="form-control" />
                                </div>
                            </div>

                            <div class="col-sm-3">
                                <div class="form-group">
                                    <label>{{$t('form.employee.email')}}</label>
                                    <input type="text" v-model="search.email" @keyup="searchProfessors"
                                        class="form-control" />
                                </div>
                            </div>

                            <div class="col-sm-3">
                                <div class="form-group">
                                    <label>{{$t('form.employee.webAddress')}}</label>
                                    <input type="text" v-model="search.webAddress" @keyup="searchProfessors"
                                        class="form-control" />
                                </div>
                            </div>

                            <div class="col-sm-6">
                                <div class="form-group">
                                    <label>{{$t('form.employee.notes')}}</label>
                                    <textarea v-model="search.notes" @keyup="searchProfessors" rows="5"
                                        class="form-control"></textarea>
                                </div>
                            </div>

                            <div class="col-12">
                                <hr />
                            </div>

                            <div class="col-sm-6">
                                <div class="form-group">
                                    <input type="text" v-model="preset.name" class="form-control"
                                        :placeholder="$t('form.employee.presetName')" />
                                </div>
                            </div>

                            <div class="col-sm-6">
                                <button class="btn btn-primary" @click="savePreset">{{$t('button.save')}}</button>
                                <button class="btn btn-danger" v-show="presetSelected"
                                    @click="deletePreset">{{$t('button.delete')}}</button>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- List -->
                <div class="card">
                    <div class="card-header bg-light">
                        <div class="card-title">{{$t('form.employee.professorList')}}</div>
                    </div>

                    <div class="card-body table-responsive p-0">
                        <table class="table table-hover">
                            <thead>
                                <tr>
                                    <th>{{$t('form.employee.name')}}</th>
                                    <th>{{$t('form.employee.position')}}</th>
                                    <th class="text-right">{{$t('form.employee.action')}}</th>
                                </tr>
                            </thead>

                            <tbody v-for="(professor, index) in professors" v-bind:key="index">
                                <tr v-on:dblclick="goToEdit(professor.ID)">
                                    <td>
                                        {{professor.FirstName }}
                                        {{professor.LastName}}
                                    </td>
                                    <td>{{professor.Position}}</td>

                                    <td class="text-right">
                                        <button v-if="permissions.viewEmployeeProfessors"
                                            class="btn btn-info btn btn-sm professorEdit"
                                            v-on:click="goToEdit(professor.ID)">
                                            <span class="fa fa-edit"></span>
                                        </button>
                                        <button v-if="permissions.deleteEmployeeProfessors"
                                            class="btn btn-danger btn btn-sm"
                                            v-on:click="deleteProfessor(professor.ID, index)">
                                            <span class="fa fa-trash"></span>
                                        </button>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>

                    <pagination v-if="pagination.last_page > 1" :pagination="pagination" :offset="5"
                        @paginate="paginate()">
                    </pagination>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    export default {
        props: ["permissions"],

        data() {
            return {
                alert: false,
                alertClass: '',
                alertMessage: '',

                isLoading: false,
                fullPage: true,

                request_source: '',
                detailedSearch: false,
                presetSelected: false,

                pagination: {
                    current_page: 1
                },

                search: {},
                preset: {
                    name: "",
                    entity: "professor",
                    value: {}
                },

                titles: [],
                presetList: [],
                allCountries: [],
                positionList: [],
                departmentList: [],
                professors: [],
            }
        },

        async mounted() {
            this.isLoading = true;

            if (!this.permissions.viewEmployeeProfessors) {
                this.$router.push("/");
                return;
            }

            await this.getInitailData();

            if (localStorage.getItem('filter-professor')) {
                this.search = JSON.parse(localStorage.getItem('filter-professor'));
            }

            this.getPresets();
            this.getProfessors();
        },

        watch: {
            search: {
                handler() {
                    localStorage.setItem('filter-professor', JSON.stringify(this.search));
                },
                deep: true
            }
        },

        methods: {
            async getInitailData() {
                let response = await axios.get('/api/professors/initial-data');
                
                if (response.data) {
                    let data = response.data;

                    this.departmentList = data.departments;
                    this.positionList = data.positions;
                    this.allCountries = data.countries;
                    this.titles = data.titles;
                }
            },

            getProfessors() {
                let source = axios.CancelToken.source();

                if (this.request_source != "") {
                    this.request_source.cancel("Operation canceled by the user.");
                    console.clear();
                }

                this.request_source = source;

                this.isLoading = true;
                axios
                    .get("/api/professors?page=" + this.pagination.current_page, {
                        params: this.search,
                        cancelToken: this.request_source.token
                    })
                    .then(response => {
                        this.isLoading = false;
                        this.professors = response.data.data.data;
                        this.pagination = response.data.pagination;
                    })
                    .catch(error => {
                        this.isLoading = false;
                        console.log(error);
                    });
            },

            paginate() {
                this.getProfessors();
            },

            searchProfessors() {
                this.pagination.current_page = 1;
                this.getProfessors();
            },

            clearSearch() {
                this.search = {};
                this.searchProfessors();
            },

            goToEdit(id) {
                if (!this.permissions.viewEmployeeProfessors) return;

                this.$router.push({
                    name: 'ProfessorEdit',
                    params: {
                        id: id
                    }
                });
            },

            deleteProfessor(id, index) {
                if (!this.permissions.deleteEmployeeProfessors) return;

                let conf = confirm(this.$t('form.validation.delete'));

                if (conf === true) {
                    axios
                        .delete("/api/professors/" + id)
                        .then(response => {
                            if (response.data.warning) {
                                this.showAlert(response.data.message, 'danger');
                            } else if (response.data.warnings) {
                                this.showAlert(response.data.message, 'danger');
                            } else {
                                this.professors.splice(index, 1);
                                this.showAlert(response.data.message);

                                if (this.professors.length < 5) this.getProfessors();
                            }
                        });
                }
            },

            savePreset() {
                this.isLoading = true;
                this.alert = false;

                this.preset.value = JSON.stringify(this.search);

                axios.post("/api/presets", this.preset).then(
                    response => {
                        this.isLoading = false;
                        this.showAlert(response.data.message);
                        this.getPresets();
                    },
                    error => {
                        this.isLoading = false;

                        if (error.response.status == 422) {
                            this.showAlert(error.response.data.errors.name[0], 'danger');
                        }
                    }
                );
            },

            getPresets() {
                axios.get("/api/presets/?entity=" + this.preset.entity).then(
                    response => {
                        this.presetList = response.data;
                    },
                    error => {
                        console.log(error.response);
                    }
                );
            },

            loadPreset() {
                if (!this.preset) {
                    this.preset = {
                        entity: "professor"
                    };
                    this.clearSearch();
                    this.alert = false;
                    this.presetSelected = false;
                    return;
                }
                this.alert = false;
                this.presetSelected = true;
                this.search = JSON.parse(this.preset.value);
                this.searchProfessors();
            },

            deletePreset() {
                let conf = confirm(this.$t('form.validation.delete'));

                if (conf === true) {
                    axios
                        .delete("/api/presets/" + this.preset.id)
                        .then(response => {
                            if (response.data.status == "success") {
                                this.showAlert(response.data.message);
                                this.getPresets();
                                this.clearSearch();
                                this.preset.name = "";
                                this.preset.value = {};
                                this.presetSelected = false;
                            }
                        })
                        .catch(error => {
                            this.isLoading = false;
                        });
                }
            },

            showAlert(msg, cls = 'success') {
                this.alertMessage = msg;
                this.alertClass = cls;
                this.alert = true;
            }
        }
    };

</script>

<style scoped>
</style>
